import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ index, eyebrow, title, dark = false, center = false }) => (
  <Reveal className={center ? "text-center" : ""}>
    <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
      <span className="overline-tag">{index}</span>
      <span className="gold-hairline w-16" aria-hidden="true" />
      <span className="overline-tag">{eyebrow}</span>
    </div>
    <h2
      className={`font-serif-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight mt-5 leading-[1.1] ${
        dark ? "text-[#3F6212]" : "text-[#365314]"
      }`}
    >
      {title}
    </h2>
  </Reveal>
);
